
import React, { Dispatch, SetStateAction } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { GameClient } from "../gameClient";
import { css } from "@emotion/react";

declare var gameClient: GameClient;

interface SettingsButtonProps {
    showSettings: (show: boolean) => void;
}

export const SettingsButton = (props: SettingsButtonProps) => {
    const showSettings = () => {
        props.showSettings(true);
    }

	return (
		<div onClick={showSettings}>
			<FontAwesomeIcon style={{color: 'white'}} size="2x" icon={faCog} />
		</div>
	)
}
